import React, { useCallback, useEffect, useRef, useState } from 'react';

import { useSelector } from 'react-redux';

import { getListReportForEvaluation } from 'api/endpoints/children';
import LayoutMain from 'components/layouts/LayoutMain';
import { OPTION_PAGINATION } from 'constants/index';
import EvaluationAnalysisHeader from 'pages/EvaluationAnalysis/List/EvaluationAnalysisHeader';
import EvaluationAnalysisPagination from 'pages/EvaluationAnalysis/List/EvaluationAnalysisPagination';
import EvaluationAnalysisTable from 'pages/EvaluationAnalysis/List/EvaluationAnalysisTable';
import { convertToQueryString } from 'utils/helper';

const EvaluationAnalysis = () => {
  const { me } = useSelector((state) => state.auth);

  const [options, setOptions] = useState({ keyword: null, ...OPTION_PAGINATION });
  const [sort, setSort] = useState([]);
  const [listEvaluationAnalysis, setListEvaluationAnalysis] = useState([]);
  const [loading, setLoading] = useState(false);

  const isCallingApi = useRef(false);

  // PAGINATION
  const onPageChange = (e) => {
    if (e !== options.page) {
      setOptions((prevState) => {
        return { ...prevState, page: e };
      });
      return true;
    }

    return false;
  };

  // SORT
  const onSortChange = (e) => {
    setSort(() => e);
  };

  /**
   * @name handleSort
   * @returns {string[]}
   * @example ['title', '-updated_at']
   * @example ['-title', 'updated_at']
   */
  const handleSort = () => {
    return (
      sort.map((item) => {
        let itemSort = item.id;
        if (['eval_created_at_1', 'eval_created_at_2', 'eval_created_at_3'].indexOf(item.id) !== -1) {
          itemSort = 'eval_created_at';
        }
        return item.desc ? `-${itemSort}` : itemSort;
      }) || []
    );
  };

  const handleGetEvaluationAnalysis = async () => {
    if (!isCallingApi.current) {
      isCallingApi.current = true;
      const sortHandle = handleSort();
      const queryString = convertToQueryString({ sort_by: sortHandle, page: options.page, page_size: options.page_size });
      setLoading(true);
      try {
        await getListReportForEvaluation(queryString)
          .then((response) => {
            const totalPage = Math.ceil(response.total / response.page_size);
            const page = response.page > totalPage ? (totalPage === 0 ? 1 : totalPage) : options.page;

            setListEvaluationAnalysis(response?.data || []);
            setOptions((prevState) => {
              return {
                ...prevState,
                total: response.total,
                page_size: response.page_size,
                page: page,
              };
            });
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      } catch {
        setLoading(false);
      } finally {
        isCallingApi.current = false;
      }
    }
  };

  const getEvaluationAnalysis = useCallback(async () => {
    if (me) {
      handleGetEvaluationAnalysis();
    }
  }, [options.page, options.keyword, sort, me]);

  useEffect(() => {
    getEvaluationAnalysis();
  }, [getEvaluationAnalysis]);

  return (
    <>
      <LayoutMain className={'!max-w-[1856px]'}>
        <section id="question-list">
          <h1 className="text-2xl font-bold text-black/85">{'評価分析一覧'}</h1>
          <EvaluationAnalysisHeader options={options} />
          <div className={`w-full mt-4 ${options.total > 0 ? 'min-h-164.75' : ''}`}>
            <EvaluationAnalysisTable
              data={listEvaluationAnalysis}
              setSort={onSortChange}
              reloadData={() => {}}
              onPageChange={onPageChange}
              sort={sort}
              page={options.page}
              keyword={options.keyword}
              isFilter={!!options.keyword || options.municipality_code}
            />
          </div>
          {options.total > 0 && <EvaluationAnalysisPagination options={options} onPageChange={onPageChange} loading={loading} />}
        </section>
      </LayoutMain>
    </>
  );
};

export default React.memo(EvaluationAnalysis);
